import { render, staticRenderFns } from "./PersistTipoRelatorioView.vue?vue&type=template&id=46e3e37d&"
import script from "./PersistTipoRelatorioView.vue?vue&type=script&lang=ts&"
export * from "./PersistTipoRelatorioView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports